import React from 'react';
import styles from './PublicationCard.module.scss';
import Separator from '../../atoms/separator/Separator';
import Text from '../../atoms/text/Text';

function PublicationCard({ publication, currentLanguage, onClick }) {
  const colorClass = 'green';
  return (
    <div
      onClick={onClick}
      className={`${styles['major-box']} ${styles[`border-${colorClass}`]}`}
    >
      <div className={`${styles['color-head']} ${styles[colorClass]}`}></div>

      <div className={styles['major-descriptions']}>
        <div className={styles['major-titles']}>
          <Text
            title={publication['Research Title AR']}
            variant="text-bold-italic-18-black"
            className={styles['title']}
            color="#1a1a1a"
            style={{ cursor: 'pointer' }}
          />

          <Text
            title={publication['Author Name AR']}
            variant="text-bold-italic-16-black"
            className={styles['sub-title']}
            color="#008556"
            style={{ cursor: 'pointer' }}
          />

          <Text
            title={`${publication.Year || ''} ${publication['Country EN'] || publication['Country AR'] ? '-' : ''} ${
              publication['Country AR'] ?? ''
            }`}
            variant="text-regular-18"
            className={styles['year']}
            color="#1a1a1a"
            style={{ cursor: 'pointer' }}
          />

          {publication['Conference EN'] && (
            <Text
              title={publication['Conference AR'] ?? ''}
              variant="text-regular-18"
              color="#1a1a1a"
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>

        <div className={styles['grid-container']}>
          <div style={{ height: '20px' }} />
          <div className={styles['grid']}>
            {publication['Journal Label EN'] && (
              <div className={styles['item']} style={{ width: '70%' }}>
                <Text
                  title="research_and_publications.Journal_Label"
                  variant="text-bold-14-black"
                  className={styles['label']}
                  style={{ cursor: 'pointer' }}
                />
                <Text
                  title={publication['Journal Label AR'] ?? ''}
                  variant="text-regular-18"
                  color="#1a1a1a"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            )}

            {publication['Journal Rating '] && (
              <div className={styles['item']} style={{ width: '70%' }}>
                <Text
                  title="research_and_publications.Journal_Rating"
                  variant="text-bold-14-black"
                  className={styles['label']}
                  style={{ cursor: 'pointer' }}
                />
                <Text
                  title={publication['Journal Rating ']}
                  variant="text-regular-18"
                  color="#1a1a1a"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            )}

            {publication.DOI && (
              <div className={styles['item']} style={{ width: '70%' }}>
                <Text
                  title="research_and_publications.DOI"
                  variant="text-bold-14-black"
                  className={styles['label']}
                  style={{ cursor: 'pointer' }}
                />
                <Text
                  title={publication.DOI}
                  variant="text-regular-18"
                  color="#1a1a1a"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            )}

            {publication['Department EN'] && (
              <div className={styles['item']} style={{ width: '70%' }}>
                <Text
                  title="research_and_publications.Department"
                  variant="text-bold-14-black"
                  className={styles['label']}
                  style={{ cursor: 'pointer' }}
                />
                <Text
                  title={publication['Department AR'] ?? ''}
                  variant="text-regular-18"
                  color="#1a1a1a"
                  style={{ cursor: 'pointer' }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicationCard;
